import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import Picture from '../../baseComponents/gui/picture/Picture';
import classNames from 'classnames';
import { bathroomBg, bathroomBgBlur } from '../../../constants/copyright';
import { useContent } from '../../../redux/reducer/content';
import Elf3D from '../../scenes/elf3D/Elf3D';
import { useBackgroundData } from '../../../hooks/useBackgroundData';
import { useUser } from '../../../redux/reducer/user';
import { CSSTransition } from 'react-transition-group';
import { useElf } from '../../../redux/reducer/elf';
import { backgroundCount, roomAvailableStates } from '../../../constants/room';
import { useBathBackgroundData } from '../../../hooks/useBathBackgroundData';
import { useTranslation } from '../../../translations';
import { useApplicationCallbacks } from '../../../providers/application-callbacks';

const Room = forwardRef(function Room({ clothItems, roomItems, isHideElf }, ref) {
  const { profile } = useUser();
  const { isVisibleRoom } = useElf();
  const { isBath, state } = useContent();

  const callbacks = useApplicationCallbacks();

  const backgroundData = useBackgroundData({ items: profile?.items });

  const bathBackgroundData = useBathBackgroundData();

  const { t } = useTranslation();

  const isTruthState = roomAvailableStates.includes(state);

  const currentItems = roomItems ?? backgroundData ?? [];

  const elfWrapperRef = useRef();
  const roomRef = useRef();

  useImperativeHandle(ref, () => ({ el: elfWrapperRef.current }));

  return (
    <div className={classNames('room', isTruthState && `room_${isBath ? 'bathroom' : 'main'}`)} ref={roomRef}>
      {isTruthState && (
        <div className={'room__bathroom'}>
          <Picture
            {...bathroomBgBlur}
            alt={t(bathroomBgBlur.imgAttr.alt)}
            imgAttr={{
              ...bathroomBgBlur.imgAttr,
              className: classNames(bathroomBgBlur.imgAttr.className, {
                'room__bathroom-background-blur_hidden': !isVisibleRoom,
              }),
            }}
          />

          {isVisibleRoom && <div className={'room__contrast-filter room__contrast-filter_bath'} />}

          <div className={'room__bathroom-center'}>
            <Picture
              {...bathroomBg}
              alt={t(bathroomBg.imgAttr.alt)}
              imgAttr={{
                ...bathroomBg.imgAttr,
                className: classNames(bathroomBg.imgAttr.className, {
                  'room__bathroom-background_hidden': !isVisibleRoom,
                }),
              }}
            />

            {bathBackgroundData.map((image, id) => (
              <img
                key={`background-element-${id}`}
                className={classNames('room__bath-image', {
                  'room__bath-image_hidden': !isVisibleRoom,
                })}
                alt={''}
                src={image}
              />
            ))}
          </div>
        </div>
      )}
      <div className={'room__main'}>
        <>
          {currentItems.slice(backgroundCount.start, backgroundCount.end).map((image, id) => (
            <img
              key={`background-blur-element-${id}`}
              className={classNames('room__image-blur room__image-blur-wall', {
                room__image_hidden: !isVisibleRoom,
              })}
              alt={''}
              src={image}
            />
          ))}

          {isVisibleRoom && <div className={'room__contrast-filter'} />}
        </>
        <div className={'room__main-center'}>
          {currentItems.map((image, id) => (
            <img
              key={`background-element-${id}`}
              className={classNames('room__image', { room__image_hidden: !isVisibleRoom })}
              alt={''}
              src={image}
            />
          ))}
        </div>
      </div>
      <CSSTransition in={!isHideElf} classNames={'elf-3d__visible'} timeout={300} mountOnEnter unmountOnExit>
        <Elf3D ref={elfWrapperRef} callbacks={callbacks} clothItems={clothItems} />
      </CSSTransition>
    </div>
  );
});

Room.displayName = 'Room';
export default Room;
